import { colors } from 'kaizen-ui-colors/lib';

export type ExperienceStateType = 'competition' | 'interim' | 'paused' | 'archived' | 'initial' | 'original';
export type RoundPurposeType = 'initial' | 'research' | 'use' | 'original';
export type TargetDeviceType = 'pc' | 'mobile';
export type RoundStateType = 'active' | 'paused';

export interface ICalculation {
  experience: IExperience;
}

export interface IExperience {
  id: string;
  title: string;
  state: ExperienceStateType;
  url: string;
  createdAt: Date;
  pageTag: IPageTag;
  rounds: IRoundInfo[];
  cvCoverageRatio: number;
  totalImprovementRatio: number;
  actualAveragePv: number;
  actualAverageCv: number;
  actualAverageCvr: number;
  targetDevice: TargetDeviceType;
  hasAllCv: boolean;
}

export interface IPageTag {
  id: string;
  name: string;
  ja: string;
  order: number;
}

export interface IRoundState {
  id: string;
  type: RoundStateType;
}

export interface IRoundInfo {
  id: string;
  type: ExperienceStateType;
  num: number;
  startedAt: Date;
  endedAt: Date;
  purposeType: RoundPurposeType;
  note: string;
  resultNote: string;
  improvementRatio: number;
  roundState: IRoundState;
}

export class PortfolioReportItem {
  public goalId: string;
  public from: Date;
  public to: Date;
  public calculations: ICalculation[];

  constructor({
    goalId,
    from,
    to,
    calculations,
  }: {
    goalId: string;
    from: Date;
    to: Date;
    calculations: ICalculation[];
  }) {
    this.goalId = goalId;
    this.from = from;
    this.to = to;
    this.calculations = calculations;
  }
}

export const stateLabel = (state: ExperienceStateType) => {
  switch (state) {
    case 'competition': {
      return '実施中';
    }
    case 'interim': {
      return 'インターバル';
    }
    case 'paused': {
      return '一時停止';
    }
    case 'archived': {
      return '終了';
    }
    case 'initial': {
      return '準備中';
    }
    default: {
      return '?';
    }
  }
};

export const roundLabel = (state: ExperienceStateType, num: number) => {
  switch (state) {
    case 'original': {
      return 'オリジナル';
    }
    case 'competition': {
      return `ラウンド ${num}`;
    }
    case 'interim': {
      return `インターバル ${num}`;
    }
    case 'initial': {
      return '準備中';
    }
    default: {
      return '?';
    }
  }
};

export const modeLabel = (mode: RoundPurposeType | RoundStateType) => {
  switch (mode) {
    case 'paused': {
      return '一時停止中';
    }
    case 'research': {
      return '探索';
    }
    case 'use': {
      return '活用';
    }
    default: {
      return '';
    }
  }
};

export const modeLabelColor = (mode: RoundPurposeType | RoundStateType) => {
  switch (mode) {
    case 'paused': {
      return colors.lithium_light__e2e6ef;
    }
    case 'research': {
      return colors.pumpkin_light__fdc133;
    }
    case 'use': {
      return colors.veggie__2dcc70;
    }
    default: {
      return colors.lithium_light__e2e6ef;
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/entity/PortfolioReportItem.ts